module.exports = __webpack_public_path__ + "media/images/home-desktop-xl-e8f9af748fd0bebbb4d9888962f64944.jpg";